// @owners { team: patients-team }
import { MedList } from '@alto/features';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { useRemoveNotifications } from '~web/hooks';

export const MedListWrapper = () => {
  useRemoveNotifications();
  const { getParam } = useNavigation<'RouteTabMyMeds'>();
  const origin = getParam('origin');

  return <MedList origin={origin} />;
};
